import { useEffect, useState, useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import { FaPlus, FaTimes } from "react-icons/fa";

export default function OpcionesAdmin({ preguntaId }) {

  const { token } = useContext(AuthContext);

  const [opciones, setOpciones] = useState([]);
  const [texto, setTexto] = useState("");
  const [toast, setToast] = useState({ mostrar: false, mensaje: "", tipo: "success" });

  const mostrarToast = (mensaje, tipo = "success") => {
    setToast({ mostrar: true, mensaje, tipo });
    setTimeout(() => setToast({ mostrar: false, mensaje: "", tipo: "success" }), 3000);
  };

  const fetchOpciones = async () => {
    if (!token) return;
    const res = await fetch(`/api/admin/opciones/${preguntaId}`, {
      credentials: "include",
      headers: { Authorization: `Bearer ${token}` },
    });
    setOpciones(await res.json());
  };

  useEffect(() => {
    fetchOpciones();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  const crear = async () => {
    if (!texto.trim()) return;

    try {
      const res = await fetch("/api/admin/opciones", {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ pregunta_id: preguntaId, texto }),
      });

      if (!res.ok) {
        mostrarToast("Error creando la opción", "error");
        return;
      }

      setTexto("");
      fetchOpciones();
    } catch (error) {
      mostrarToast("Error inesperado", "error");
    }
  };

  const quitar = async (op) => {
    try {
      const res = await fetch(`/api/admin/opciones/${op.id}`, {
        method: "DELETE",
        credentials: "include",
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) {
        mostrarToast("Error quitando la opción", "error");
        return;
      }
      fetchOpciones();
    } catch (error) {
      mostrarToast("Error inesperado", "error");
    }
  };

  return (
    <div>
      {toast.mostrar && (
        <div className={`fixed top-5 right-5 z-[70] px-4 py-3 rounded-lg shadow-lg text-sm text-white ${toast.tipo === "success" ? "bg-emerald-600" : "bg-rose-600"}`}>
          {toast.mensaje}
        </div>
      )}

      <p className="text-xs font-medium text-slate-500 mb-1.5">Opciones</p>

      <div className="flex gap-2 mb-2">
        <input
          value={texto}
          onChange={(e) => setTexto(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && crear()}
          placeholder="Nueva opción"
          className="flex-1 border border-slate-200 rounded-lg px-2.5 py-1.5 text-xs bg-white focus:outline-none focus:ring-2 focus:ring-indigo-200 focus:border-indigo-400"
        />
        <button
          onClick={crear}
          className="flex items-center gap-1 bg-slate-700 hover:bg-slate-800 text-white text-xs font-medium px-2.5 py-1.5 rounded-lg transition"
        >
          <FaPlus className="text-[10px]" /> Agregar
        </button>
      </div>

      {opciones.length > 0 && (
        <div className="flex flex-wrap gap-1.5">
          {opciones.map((op) => (
            <span
              key={op.id}
              className="flex items-center gap-1.5 bg-white border border-slate-200 rounded-full pl-2.5 pr-1.5 py-1 text-xs text-slate-600"
            >
              {op.texto}
              <button
                onClick={() => quitar(op)}
                className="w-4 h-4 flex items-center justify-center rounded-full text-slate-400 hover:bg-rose-50 hover:text-rose-500 transition"
                title="Quitar opción"
              >
                <FaTimes className="text-[9px]" />
              </button>
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
